import { StateCreator } from 'zustand';

import { ErrorReportingState } from './types/ErrorReportingState';
import { ErrorReportingStateDependencies } from './types/ErrorReportingStateDependencies';

export const errorReportingStore =
  ({
    reporter,
  }: ErrorReportingStateDependencies): StateCreator<ErrorReportingState> =>
  () => ({
    captureException: reporter.captureException,
    init: reporter.init,
    setAdditionalData: reporter.setAdditionalData,
    setUser: reporter.setUser,
    wrapCreateBrowserRouter: reporter.wrapCreateBrowserRouter,
  });
